/**
 * The Overview "Mock Tests" row counts every tier, so it must link to a tier
 * that actually has mocks. UCAT, ESAT and TARA have no Beginnings mocks, so a
 * fixed link to Beginnings landed on an empty page while the row claimed a
 * non-zero total. Falls back to Beginnings when every tier is empty, which is
 * the page that explains there is nothing yet.
 */
export function firstPopulatedMockTier(beginnings, foundations, beyond) {
  const count = (rows) => (Array.isArray(rows) ? rows.length : 0);
  if (count(beginnings)) return 'mock-beginnings';
  if (count(foundations)) return 'mock-foundations';
  if (count(beyond)) return 'mock-beyond';
  return 'mock-beginnings';
}
